import {
  LegacyCard,
  Page,
  TextField,
  Layout,
  FormLayout,
  Form,
  FooterHelp,
  TextContainer,
  SkeletonPage,
  SkeletonBodyText,
} from '@shopify/polaris';
import React, { useState, useEffect, useContext } from 'react';

import { checkUser, editUserId, getUserId } from '../../../services/userService.js';
import ToastContext from '../../../context/ToastContext';
import { SET_OK, SET_ERROR } from '../../../context/ToastReducer';

const EditUser = () => {
  const { id } = checkUser().user;
  const [, dispatchToast] = useContext(ToastContext);

  const defaultEdit = {
    name: '',
    surname: '',
    phone: '',
    email: '',
    password: '',
    admin: false,
  };

  const [user, setUser] = useState(null);
  const [edit, setEdit] = useState(defaultEdit);
  const [pwconfirm, setPwconfirm] = useState(false);
  const [pwconfirmValue, setPwconfirmValue] = useState('');

  useEffect(() => {
    getUserId(id).then((u) => {
      setUser(u.data);
      setEdit({
        ...u.data,
        role: u.data.role.slug,
      });
    });
    // eslint-disable-next-line
  }, []);

  const handleSubmit = () => {
    editUserId(id, edit)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: { message: 'Datos cambiados' } });
        getUserId(id).then((u) => setUser(u.data));
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  return (
    <>
      {!user && (
        <SkeletonPage primaryAction>
          <Layout>
            <Layout.AnnotatedSection
              id="editUser"
              title="Editar usuario"
              description={
                <>
                  <strong>Nota:</strong> Si no se cambia la contraseña, se mantendrá la actual
                </>
              }
            >
              <LegacyCard>
                <LegacyCard.Section>
                  <TextContainer>
                    <SkeletonBodyText />
                  </TextContainer>
                </LegacyCard.Section>
                <LegacyCard.Section>
                  <TextContainer>
                    <SkeletonBodyText />
                  </TextContainer>
                </LegacyCard.Section>
              </LegacyCard>
            </Layout.AnnotatedSection>
            <Layout.AnnotatedSection
              id="editUser"
              title="Modificar contraseña"
              description="Introduzca la nueva contraseña dos veces para confirmarla"
            >
              <LegacyCard sectioned>
                <TextContainer>
                  <SkeletonBodyText />
                </TextContainer>
              </LegacyCard>
            </Layout.AnnotatedSection>
          </Layout>
        </SkeletonPage>
      )}

      {user && (
        <>
          <Page title={user.name} subtitle={user.email} divider>
            <Layout>
              <Layout.AnnotatedSection
                id="editUser"
                title="Editar usuario"
                description={
                  <>
                    <strong>Nota:</strong> Si no se cambia la contraseña, se mantendrá la actual
                  </>
                }
              >
                <LegacyCard
                  primaryFooterAction={{
                    content: 'GUARDAR CAMBIOS',
                    onClick: (e) => handleSubmit(),
                  }}
                >
                  <LegacyCard.Section>
                    <Form onSubmit={handleSubmit}>
                      <FormLayout>
                        <TextField
                          label="Nombre"
                          type="name"
                          placeholder={edit.name}
                          value={edit.name}
                          autoComplete="off"
                          onChange={(e) =>
                            setEdit({
                              ...edit,
                              name: e,
                            })
                          }
                        />
                        <TextField
                          label="Apellidos"
                          type="text"
                          placeholder={edit.surname}
                          value={edit.surname}
                          autoComplete="off"
                          onChange={(e) =>
                            setEdit({
                              ...edit,
                              surname: e,
                            })
                          }
                        />
                        <TextField
                          label="Email"
                          type="email"
                          placeholder={edit.email}
                          value={edit.email}
                          autoComplete="off"
                          onChange={(e) =>
                            setEdit({
                              ...edit,
                              email: e,
                            })
                          }
                        />
                        <TextField
                          label="Teléfono"
                          type="tel"
                          placeholder={edit.phone}
                          value={edit.phone}
                          autoComplete="off"
                          onChange={(e) =>
                            setEdit({
                              ...edit,
                              phone: e,
                            })
                          }
                        />
                        <TextField label="Rol" value={user.role.name} disabled={true} />
                      </FormLayout>
                    </Form>
                  </LegacyCard.Section>
                </LegacyCard>
              </Layout.AnnotatedSection>
              <Layout.AnnotatedSection
                id="editUser"
                title="Modificar contraseña"
                description="Introduzca la nueva contraseña dos veces para confirmarla"
              >
                <LegacyCard
                  primaryFooterAction={{
                    content: 'CAMBIAR CONTRASEÑA',
                    onClick: (e) => handleSubmit(),
                    disabled: !pwconfirm,
                  }}
                >
                  <LegacyCard.Section>
                    <Form onSubmit={handleSubmit}>
                      <FormLayout>
                        <TextField
                          label="Contraseña"
                          type="password"
                          placeholder="Cambiar Contraseña"
                          value={edit.password}
                          autoComplete="off"
                          onChange={(e) => {
                            setEdit({
                              ...edit,
                              password: e,
                            });
                            setPwconfirm(e !== '' && e === edit.password);
                          }}
                        />
                        <TextField
                          label="Repetir Contraseña"
                          type="password"
                          placeholder="Repetir Contraseña"
                          value={pwconfirmValue}
                          onChange={(e) => {
                            setPwconfirmValue(e);
                            setPwconfirm(e !== '' && e === edit.password);
                          }}
                          error={pwconfirmValue !== '' && !pwconfirm ? 'Las contraseñas no coinciden' : ''}
                        />
                      </FormLayout>
                    </Form>
                  </LegacyCard.Section>
                </LegacyCard>
              </Layout.AnnotatedSection>
            </Layout>
          </Page>
          <FooterHelp>
            <TextContainer>
              <p>
                <small>
                  Creado el {edit.createdAt && new Date(edit.createdAt).toLocaleString('es-ES')} | Última conexión:{' '}
                  {edit.lastLogin ? new Date(edit.lastLogin).toLocaleString('es-ES') : 'Nunca'} | Última modificación:{' '}
                  {edit.updatedAt && new Date(edit.updatedAt).toLocaleString('es-ES')}{' '}
                </small>
              </p>
            </TextContainer>
          </FooterHelp>
        </>
      )}
    </>
  );
};
export default EditUser;
